(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lotto/components/start/assets/javascripts/init.js') >= 0) return;  svs.modules.push('/modules/lotto/components/start/assets/javascripts/init.js');

'use strict';

svs.numbergames.game.utils.createGameDraw({
  product: svs.numbergames.productMapping.CONSTANTS.LOTTO
});

 })(window);